<!--
(24년 5월버전) 글씨,여백등 작게 수정
트래킹검수 > 검수화면 > 검수대상 리스트 > 요청사항 컴포넌트
 - 요청사항 확인(체크) 기능이 있음
------------------------------------
-->
<template>
    <div class="root" :class="classObj">
        <!-- 요청사항 있음 -->
        <div
            class="msg"

            v-if="request"
            v-html="requestBr"

            @click="checked = ! checked"
            title="click to confirm"
        >
        </div>

        <!-- 요청사항 없음 -->
        <slot v-if="! request" name="none" >
            <div class="none">
                요청사항이 없습니다
            </div>
        </slot>
    </div>

</template>

<script>
export default {
    props: {
        // 요청사항
        request: {
            type: String,
            default: null,
        },
    },
    data: function () {
        return {
            // (bool) 확인여부
            checked: false,
        };
    },
    computed: {
        /**
         * css 클래스명 object
         */
        classObj: function () {
            return {
                checked: this.checked,
            };
        },

        /**
         * br 태그 적용
         * @returns {string}
         */
        requestBr: function () {
            if (this.request === null) {
                return '';
            }
            return this.request.replace(/(?:\r\n|\r|\n)/g, '<br />');
        },
    },

    methods: {},
}
</script>

<style lang="scss" scoped>
.root {
    margin: 0;
    padding: 0;
    background-color: #ffff99;
    text-align: left;

    .msg {

        margin: 0;
        border: 0;
        padding: 5px;


        color: #000;
        font-size: 1rem;

        cursor: pointer;
    }

    &.checked .msg {
        text-decoration-line: line-through;

        background-color: #fefefe;
        color: #999;
    }


    .none {
        background-color: #fff;
        color: #999;
    }
}

</style>